export enum Field {
  FARHANGIAN = 29,
}
// OMOMI = 17,
// RIAZI_FIZIK = 18,
// OLOM_ENSANI = 19,
// OLOM_TAJROBI = 20,
// HONAR = 28,
